import { render, staticRenderFns } from "./ContactsSection.vue?vue&type=template&id=a8180ae0&scoped=true&"
import script from "./ContactsSection.vue?vue&type=script&lang=js&"
export * from "./ContactsSection.vue?vue&type=script&lang=js&"
import style0 from "./ContactsSection.vue?vue&type=style&index=0&id=a8180ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8180ae0",
  null
  
)

export default component.exports